import { render, staticRenderFns } from "./uf_result_natural_f.vue?vue&type=template&id=e97263aa&scoped=true"
import script from "./uf_result_natural_f.vue?vue&type=script&lang=js"
export * from "./uf_result_natural_f.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e97263aa",
  null
  
)

export default component.exports